var SCM = SCM || {};

(function (al, $) {

    al.init = function () {
        var $articleLinkWidgets = $('.widget-ArticleLinks');
        if (!$articleLinkWidgets.length) {
            return;
        } 
        $articleLinkWidgets.each(function () {
            var $this = $(this);
            var $viewMoreLinkDiv = $this.find('.js-view-more-div');
            var $viewLessLinkDiv = $this.find('.js-view-less-div');
            var $viewMoreLink = $this.find('.js-view-more-div > .js-view-more-a');
            var $viewLessLink = $this.find('.js-view-less-div > .js-view-less-a');
            var $rowsToHideUnhide = $this.find('.cc-row.js-more');
            if ($viewMoreLink.length) {
                $viewMoreLink.on('click', function () {
                    $rowsToHideUnhide.removeClass('hide');
                    $viewLessLinkDiv.removeClass('hide');
                    $viewMoreLinkDiv.addClass('hide');
                });
            }
            if ($viewLessLink.length) {
                $viewLessLink.on('click', function () {
                    $rowsToHideUnhide.addClass('hide');
                    $viewLessLinkDiv.addClass('hide');
                    $viewMoreLinkDiv.removeClass('hide');
                });
            }
        });
    };
})(SCM.ArticleLinks = SCM.ArticleLinks || {}, jQuery);
